var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import * as React from "react";
import styled from "styled-components";
import { Stepper, StepLabel, Step } from "@material-ui/core";
import { useTypedSelector } from "../../state/store";
import ThemeProviderContext from "../../contexes/themeProviderContext";
var StyledStepper = styled(Stepper)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var providedStyles = _a.providedStyles;
  return providedStyles;
});
var StageVisualizer = function () {
  var themeProvider = React.useContext(ThemeProviderContext);
  var activeStep = useTypedSelector(function (state) {
    return state.peerReviews.activeStep;
  });
  var quiz = useTypedSelector(function (state) {
    return state.quiz;
  });
  var quizDisabled = useTypedSelector(function (state) {
    return state.quizAnswer.quizDisabled;
  });
  var languageInfo = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });
  if (!languageInfo || !quiz) {
    return React.createElement("div", null);
  }
  if (quizDisabled) {
    return React.createElement("div", {
      style: {
        display: "none"
      }
    });
  }
  var stageLabels = languageInfo.stage;
  var steps = [stageLabels.answerStageLabel, stageLabels.givingPeerReviewsStageLabel, stageLabels.receivingPeerReviewsStageLabel, stageLabels.evaluationStageLabel];
  return React.createElement(StyledStepper, {
    activeStep: activeStep,
    alternativeLabel: true,
    providedStyles: themeProvider.stepperStyles
  }, steps.map(function (label, index) {
    return React.createElement(Step, {
      key: label,
      "aria-current": activeStep == index
    }, React.createElement(StepLabel, null, label));
  }));
};
export default StageVisualizer;
var templateObject_1;